import ReadOnlyInput from '@core/components/Inputs/ReadOnlyInput';
import { Grid } from '@material-ui/core';
import InputMonetario from 'app/components/Input/InputMonetario';
import { getCurrency } from 'app/utils/monetarioUtil';
import React, { useEffect } from 'react';

const CompraAcrescimosDescontos = ({ id, values, handleChange, handleBlur, disabled, valorTotal }) => {
  const juros = values?.valorJuros;
  const multa = values?.valorMulta;
  const desconto = values?.valorDesconto;

  useEffect(() => {
    const jurosNum = juros || 0;
    const multaNum = multa || 0;
    const descontoNum = desconto || 0;
    const valorTotalNum = valorTotal || 0;

    const valorPago = valorTotalNum + jurosNum + multaNum - descontoNum;

    handleChange({
      target: {
        id: `${id}.valorPago`,
        value: valorPago,
      },
    });
    // Memoização intencional: as funções/props são recriadas a cada render e incluí-las
    // anularia o memo; o estado que elas leem já está nas dependências.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [juros, multa, desconto, valorTotal]);

  const getValorPago = (values, valorTotal) => {
    const juros = values?.valorJuros || 0;
    const multa = values?.valorMulta || 0;
    const desconto = values?.valorDesconto || 0;

    const acrescimoDesconto = juros + multa - desconto;
    const valorPago = (parseFloat(valorTotal) || 0) + acrescimoDesconto;

    return isNaN(valorPago) ? '-' : getCurrency(valorPago);
  };

  return (
    <>
      <Grid item xs={12} sm={3}>
        <InputMonetario
          fullWidth
          id={`${id}.valorJuros`}
          label="Juros (R$)"
          onBlur={handleBlur}
          value={values?.valorJuros}
          handleChange={handleChange}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputMonetario
          fullWidth
          id={`${id}.valorMulta`}
          label="Multa (R$)"
          onBlur={handleBlur}
          value={values?.valorMulta}
          handleChange={handleChange}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputMonetario
          fullWidth
          id={`${id}.valorDesconto`}
          label="Desconto (R$)"
          onBlur={handleBlur}
          value={values?.valorDesconto}
          handleChange={handleChange}
          disabled={disabled}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <ReadOnlyInput
          fullWidth
          id={`${id}.valorPago`}
          label="Valor pago (R$)"
          onBlur={handleBlur}
          onChange={handleChange}
          value={getValorPago(values, valorTotal)}
        />
      </Grid>
    </>
  );
};
export default CompraAcrescimosDescontos;
